// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Products from "../views/Products.vue";

export default [
  {
    path: "/products",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Products",
        component: Products,
        meta: {
          title: "Products",
        },
      },
    ],
  },
];
